export default {
	name: 'returnBooks',
	data() {
		return {
			payMoney: 0,
			payType: 1,
			searchText: '',
			searchBookCode: '',
			getReturnBookByCustomerCode: {},
			getBook: {},
			customer: null,
			books: [],
			borrowCount: 0,
			returnCount: 0,
			getDay: {},
			OperatorID: this.$store.state.user.UserID,
			ShopID: this.$store.state.user.ShopID,
			actioning: false
		}
	},
	created() {
		this.getDay = function(v) {
			let date = new Date(v.replace(/-/g, '/'));
			let now = new Date();
			return Math.ceil((now - date) / 1000 / 60 / 60 / 24) + '天';
		}

		this.getReturnBookByCustomerCode = function() {
			this.$request.request({
				url: 'borrowAndReturn/getReturnBookByCustomerCode',
				data: {
					searchText: this.searchText
				},
				method: 'post'

			}).then(res => {
				if (res.result) {
					this.customer = res.customer;
					this.searchText = this.customer.CustomerPhone;
					this.books = res.customerOrderBook;
				} else {
					this.$uil.showMessage({
						text: res.message
					});
				}
			})
		}

		this.getBook = function() {
			if (this.customer == null) {
				this.$uil.showMessage({
					text: '请先确认会员信息'
				});
				return;
			}
			if (this.customer.CustomerState > 1) {
				this.$uil.showMessage({
					text: '会员停止服务'
				});
				return;
			}
			if (this.customer.areaID != this.$store.state.user.areaID) {
				this.$uil.showMessage({
					text: '非此地区会员'
				});
				return;
			}

			this.$request.request({
				url: 'borrowAndReturn/getBookByBookCode',
				data: {
					searchText: this.searchBookCode.trim()
				},
				method: 'post'
			}).then(res => {
				if (res.result) {
					let book = res.book;
					if (book.BooksSate != 2) {
						this.$uil.showMessage({
							text: '该书未借出'
						});
						this.searchBookCode = '';
						return;
					}
					 
					if (book.returnOrders.filter(x => x.CustomerID == this.customer.CustomerID).length >
						0) {
						this.$uil.showMessage({
							text: '请到微信还书单还书'
						});
						this.searchBookCode = '';
						return;
					}
					for (let i of this.books) {
						if (i.BooksID == book.BooksID) {
							for (let j of i.books) {
								if (j.ReturnBookDetailID == book.BookDetailID) {
									this.$uil.showMessage({
										text: '请勿重复扫描'
									});
									this.searchBookCode = '';
									return;
								}
							}
						}
					}

					for (let i of this.books) {
						if (i.BooksID == book.BooksID) {
							for (let j of i.books) {
								if (j.BookDetailID == book.BookDetailID) {
									if (this.getDay(j.BorrowDate) > 30)
										this.payMoney = this.payMoney + this.getDay(j.BorrowDate) - 30;
									j.ReturnBooksNumCode = book.BooksNumCode;
									j.ReturnBookDetailID = book.BookDetailID;
									if (this.$store.state.user.ShopID == book.ShopID)
										j.ReturnBackPlace = book.CurrentPlace;
									if (this.$store.state.user.ShopID == book.OriginalShopID)
										j.ReturnBackPlace = book.OriginalCurrentPlace;
									this.returnCount++;
									this.searchBookCode = '';
									return;
								}
							}

						}
					}

				} else {
					this.$uil.showMessage({
						text: res.message
					});
				}
			})


		}
	},
	methods: {
		searchBook(e) {

			if (e.keyCode == 13)
				this.getBook();
		},
		searchCustomers(e) {

			if (e.keyCode == 13)
				this.getReturnBookByCustomerCode();
		},
		cancleReturnBook(i, j) {
			this.books[i].books[j].ReturnBookDetailID = 0;
			this.books[i].books[j].ReturnBackPlace = '';
			this.books[i].books[j].Remarks = '';
			this.books[i].books[j].ReturnBooksNumCode = '';
			this.returnCount--;
		},
		returnBooks() {
			if (this.actioning) {
				this.$uil.showMessage({
					text: '数据提交中'
				});
				return;
			}
			this.actioning = true;
			let returnBooks = [];

			for (let i of this.books) {
				for (let j of i.books) {
					if (j.ReturnBookDetailID != 0) {
						returnBooks.push({
							CustomerOrderID: i.CustomerOrderID,
							CustomerOrderBooksDetailID: j.CustomerOrderBooksDetailID,
							BookID: i.BooksID,
							BookDetailID: j.ReturnBookDetailID,
							ShopID: this.$store.state.user.ShopID,
							Remarks: j.Remarks,
							CurrentPlace: j.ReturnBackPlace,
							days: this.getDay(j.BorrowDate).replace('天', '')
						});
					}
				}

			}


			this.$request.request({
				url: 'borrowAndReturn/returnBook',
				data: {
					CustomerID: this.customer.CustomerID,
					ShopID: this.$store.state.user.ShopID,
					PayMoney: this.payMoney,
					type: this.payType,
					OperatorID: this.$store.state.user.UserID,
					retrunBook: JSON.stringify(returnBooks),
				},
				method: 'post'

			}).then(res => {
				this.$uil.showMessage({
					text: res.message
				});
				this.getReturnBookByCustomerCode();
				this.returnCount = 0;
				this.customer = null;
				this.books = [];
				this.actioning = false;
			});

		}

	},
	computed: {


		checkReturn() {
			//for (let i of this.books) {
			//	for (let j of i.books) {
			//		if (j.ReturnBookDetailID > 0) {
			//			if (j.ReturnBackPlace == '' && j.BorrowOutPlace != '') return false;
			//		}
			//	}
			//}
			return true;

		}
	}

}
